// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"714ee6d6","455":"bc7cf03d","977":"86ed8c6c"}[chunkId] + ".chunk.js";
};